import React from "react";
import Navbar from "./Navbar/Navbar.js";
import Home from "./Home/Home.js";
import Projects from "./Projects/Projects.js";
import Project from "./Projects/Project.js";
import Contact from "./Contact/Contact.js";
import Study from "./Study/Study.js";

import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  ScrollRestoration,
} from "react-router-dom";

// 1. Definimos el contenedor visual raíz (Layout)
function RootLayout() {
  return (
    <>
      {/* El componente nativo ahora funcionará perfectamente aquí */}
      <ScrollRestoration
      // getKey={(location) => {
      //   return location.pathname;
      // }}
      />

      {/* Tu barra de navegación se mantiene fija en todas las páginas */}
      <Navbar />

      {/* Aquí React Router inyectará automáticamente Home, Projects, etc. */}
      <main>
        <Outlet />
      </main>
    </>
  );
}

// 2. Configuramos la estructura de objetos para el nuevo Router
const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />, // Este layout envuelve a todos los hijos
    children: [
      { path: "/", element: <Home /> },
      { path: "/proyectos", element: <Projects /> },
      { path: "/proyectos/:id", element: <Project /> },
      { path: "/estudio", element: <Study /> }, // Placeholder para la página de equipo
      { path: "/contacto", element: <Contact /> },
    ],
  },
]);

// 3. Tu componente App simplemente entrega la configuración a la aplicación
function App() {
  return <RouterProvider router={router} />;
}

export default App;

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/proyectos" element={<Projects />} />
//         <Route path="/proyectos/:id" element={<Project />} />
//         {/* <Route path="/nosotros" element={<About />} /> */}
//         <Route path="/contacto" element={<Contact />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
